export function roiCalculator() {
    const sliderRange = document.querySelector(".calculator-range input[type='range']");
    const sliderRangeCurrent = document.querySelector(".calculator-range .slider-step-current");
    const sliderRangeSteps = $(".calculator-range .slider-step span");
    const calculatorType = $(".calculator-type-list .item");
    const calculatorTypeButton = calculatorType.find("button");
    const calculatorResultItems = $(".roi-calculator-result-numbers .item");
    const calculatorResultChartItems = $(".roi-calculator-result .chart .line");

    sliderRange.addEventListener("input", (event) => {
        const tempSliderValue = event.target.value;
        sliderRangeCurrent.textContent = sliderRangeSteps.eq(tempSliderValue).text();

        const progress = (tempSliderValue / sliderRange.max) * 100;

        sliderRange.style.background = `linear-gradient(to right, #D71612 ${progress}%, #DDDCE0 ${progress}%)`;

        calculatorResult();

    });

    function calculatorResult() {
        let activeType = calculatorType.find(".active");
        let activeTypeData = activeType.data("result");
        let currentIndex = +sliderRange.value;
        let chartHeightNumber = 0;
        calculatorResultItems.each(function (i, it) {
            let number = activeTypeData[currentIndex][i];
            $(it).find(".number").text(number);

            let cleanNumber = number.replace(/,/g, '').replace('$', '');

            if (+chartHeightNumber < +cleanNumber) {
                chartHeightNumber = cleanNumber;
            }
        });

        calculatorResultChartItems.each(function (i, it) {
            let currentHeight;
            let chartHeight = chartHeightNumber * 1.5;
            let numberChart = $("body").find(".roi-calculator-result-numbers .item").eq(i).find(".number").text().replace(/,/g, '').replace('$', '');
            currentHeight = (+numberChart / +chartHeight) * 100;
            $(it).find("span").css({
                "height": currentHeight + "%",
            });
        });
    }

    calculatorResult();

    calculatorTypeButton.on("click", function () {
        calculatorTypeButton.removeClass("active");
        $(this).addClass("active");

        calculatorResult();
    });
    sliderRangeSteps.on("click", function (e) {
        e.preventDefault();

        let stepIndex = $(this).parent().index();
        sliderRange.value = stepIndex;

        sliderRangeCurrent.textContent = sliderRangeSteps.eq(stepIndex).text();

        const progress = (stepIndex / sliderRange.max) * 100;

        sliderRange.style.background = `linear-gradient(to right, #D71612 ${progress}%, #DDDCE0 ${progress}%)`;

        calculatorResult();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/roiCalculator.js